
import React, { memo } from 'react';
import { NodeType } from '../types';

interface SidebarDockProps {
    onAddNode: (type: NodeType, position?: { x: number; y: number }, initialData?: any) => void;
    /** 「上传」按钮：单击直接弹出文件选择（与画布双击菜单「上传」同链路）；未传则回退为新建空媒体上传节点 */
    onUploadClick?: () => void;
}

// 视觉底图为设计稿 443:227 导出的完整工具栏（含 48x489 圆角底框 + 3 条分隔线 + 11 个图标）；
// 此处仅叠加透明热区，y 为各图标在设计稿中的中心坐标
const DOCK_ITEMS: { key: string; y: number; name: string; nodeType?: NodeType }[] = [
    { key: 'text', y: 24, name: '文本', nodeType: NodeType.TEXT_NODE },
    { key: 'image', y: 66, name: '图片', nodeType: NodeType.IMAGE_GENERATOR },
    { key: 'detail-page', y: 108, name: '详情页', nodeType: NodeType.DETAIL_PAGE },
    { key: 'layer-edit', y: 151, name: '图层编辑', nodeType: NodeType.LAYER_EDIT },
    { key: 'video', y: 199, name: '视频', nodeType: NodeType.VIDEO_GENERATOR },
    { key: 'video-edit', y: 241, name: '智能剪辑', nodeType: NodeType.VIDEO_COMPOSE },
    { key: 'director', y: 283, name: '导演台', nodeType: NodeType.DIRECTOR },
    { key: 'script', y: 325, name: '脚本', nodeType: NodeType.SCRIPT_NODE },
    { key: 'audio', y: 374, name: '音频', nodeType: NodeType.AUDIO_GENERATOR },
    { key: 'asset', y: 423, name: '资产' },
    { key: 'upload', y: 465, name: '上传', nodeType: NodeType.MEDIA_UPLOAD },
];

export const SidebarDock: React.FC<SidebarDockProps> = memo(({ onAddNode, onUploadClick }) => {
    return (
        <div className="fixed left-6 top-1/2 -translate-y-1/2 z-50 select-none animate-in slide-in-from-left-10 duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]">
            <div className="relative w-12 h-[489px]">
                <img
                    src="/icons/left-toolbar.svg"
                    alt=""
                    width={48}
                    height={489}
                    draggable={false}
                    className="absolute inset-0 pointer-events-none drop-shadow-[0_4px_16px_rgba(0,0,0,0.5)]"
                />
                {DOCK_ITEMS.map((item) => {
                    const disabled = !item.nodeType;
                    return (
                        <div key={item.key} className="absolute left-0 w-12 h-[42px]" style={{ top: item.y - 21 }}>
                            <div className="relative w-full h-full group">
                                <button
                                    disabled={disabled}
                                    onClick={() => {
                                        // 「上传」：单击直接弹文件选择（选完自动在视口中心建节点上传）
                                        if (item.key === 'upload' && onUploadClick) { onUploadClick(); return; }
                                        if (item.nodeType) onAddNode(item.nodeType);
                                    }}
                                    className={`w-full h-full rounded-xl transition-all duration-200 active:scale-95 ${disabled ? 'cursor-default' : 'cursor-pointer hover:bg-white/10 active:bg-white/15'}`}
                                    aria-label={item.name}
                                />
                                {disabled && <div className="absolute inset-0 rounded-xl bg-[#1D1D1D]/55 pointer-events-none" />}
                                <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-4 py-2 rounded-lg bg-[#0D0D0D]/90 backdrop-blur-[8px] text-[14px] leading-[14px] text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                                    {item.name}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
